
export class ArrayShuffle {
    public static shuffle(array: any[]): any[] {
        let len: number = array.length;
        let arr2: any[] = new Array(len);

        for (let i: number = 0; i < len; i++) {
            arr2[i] = array.splice(Number(Math.random() * (len - i)), 1)[0];
        }
        return arr2;
    }
}
